import {
  UPDATE_LOGIN_MODAL,
  UPDATE_ADD_HACK_MODAL,
  UPDATE_SHARE_NEWS_MODAL,
  UPDATE_ADD_REVIEW_MODAL,
  UPDATE_RESET_PASSWORD_MODAL,

  UPDATE_COMPANY_MODAL,
  UPDATE_HACKER_MODAL,
  UPDATE_ORGANIZER_MODAL,

  CLOSE_ALL_MODALS,
} from 'src/constants/actionTypes';

const DEFAULT_STATE = {
  loginOpened: false,
  addHackathonOpened: false,
  shareNewsOpened: false,
  companyOpened: false,
  hackerOpened: false,
  organizerOpened: false,
  addReviewOpened: false,
  resetPasswordOpened: false,
  resetToken: undefined,
};

export default (state = DEFAULT_STATE, action) => {
  const { type, opened } = action;

  if (type === UPDATE_LOGIN_MODAL) {
    return {
      ...DEFAULT_STATE,
      loginOpened: opened,
    };
  }
  if (type === UPDATE_ADD_HACK_MODAL) {
    return {
      ...DEFAULT_STATE,
      addHackathonOpened: opened,
    }
  }
  if (type === UPDATE_ADD_REVIEW_MODAL) {
    return {
      ...DEFAULT_STATE,
      addReviewOpened: opened,
    }
  }
  if (type === UPDATE_SHARE_NEWS_MODAL) {
    return {
      ...DEFAULT_STATE,
      shareNewsOpened: opened,
    }
  }

  if (type === UPDATE_COMPANY_MODAL) {
    return {
      ...DEFAULT_STATE,
     companyOpened: opened,
    };
  }
  if (type === UPDATE_HACKER_MODAL) {
    return {
      ...DEFAULT_STATE,
     hackerOpened: opened,
    };
  }
  if (type === UPDATE_ORGANIZER_MODAL) {
    return {
      ...DEFAULT_STATE,
     organizerOpened: opened,
    };
  }

  if (type === UPDATE_RESET_PASSWORD_MODAL) {
    return {
      ...DEFAULT_STATE,
      resetPasswordOpened: opened,
      resetToken: action.resetToken,
    }
  }
  if (type === CLOSE_ALL_MODALS) {
    return {
      ...DEFAULT_STATE,
    };
  }
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/modalWindows.js